import React, { useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { isEmpty } from 'ramda'
import styled from 'styled-components'

import { filterProps, toRankingOptions, formatFilters } from 'services/utils'
import formatter from 'services/formatter'

import {
  DATE_FIELDS,
  selectFilter,
  removeFilter,
  removeAllFilters,
} from 'store/modules/users/ordersForCollect/reducer'

import { Box, Tooltip } from '@material-ui/core'

import Trash from 'components/Icons/Trash'
import Chip from 'components/Chip'
import Ranking from 'components/Ranking'
import SideBar from 'components/SideBar'

import {
  FormDatePicker,
  FormCombobox,
  Form,
  FormTextField,
} from 'components/CoForm'
import { Title, Divider } from '@/components/Ranking/styles'
import { Button } from '@/components'

// --------------- 𝕌𝕥𝕚𝕝𝕤 ---------------

const formatDates = (filter) =>
  DATE_FIELDS.includes(filter[filterProps.BY])
    ? {
        ...filter,
        value: formatter(filter[filterProps.VALUE]).toSimpleDate(),
      }
    : filter

// --------------- ℂ𝕠𝕞𝕡𝕠𝕟𝕖𝕟𝕥𝕤 ---------------

const StyledTrashIcon = styled(Trash)`
  margin-right: 20px;

  cursor: pointer;
  path {
    fill: ${(props) => props.theme.palette.primary.main};
  }
`

// --------------- 𝕄𝕒𝕚𝕟 ---------------

export default function Filters({ selectedFilters }) {
  const dispatch = useDispatch()

  const formSearchRef = useRef(null)

  const loading = useSelector((state) => state.users.ordersForCollect.loading)

  const ufs = useSelector(
    (state) => state.users.ordersForCollect.filters.dsc_uf
  )

  const cities = useSelector(
    (state) => state.users.ordersForCollect.filters.cidade_cliente
  )

  const customers = useSelector(
    (state) => state.users.ordersForCollect.filters.cliente_nome
  )

  const carriers = useSelector(
    (state) => state.users.ordersForCollect.filters.trp_nome
  )

  function handleRemoveAllFilters() {
    dispatch(removeAllFilters())
  }

  function handleSelectFilter(filter) {
    dispatch(selectFilter(filter))
  }

  function handleSubmit(values) {
    formatFilters(values).forEach((filter) => {
      handleSelectFilter(filter)
    })

    formSearchRef.current.reset()
  }

  return (
    <SideBar
      loading={loading}
      HeaderComponent={
        !isEmpty(selectedFilters) ? (
          <div className="ChipList ChipListSpacing">
            {selectedFilters.map(formatDates).map((filter, index) => (
              <Chip
                onDelete={() => dispatch(removeFilter(filter))}
                label={filter.value}
                key={index}
              />
            ))}
            <Tooltip title="Excluir filtros">
              <div>
                <StyledTrashIcon onClick={handleRemoveAllFilters} />
              </div>
            </Tooltip>
          </div>
        ) : null
      }
      ContentComponent={
        <Box>
          <Box display="flex" flexDirection="column" gridGap="1rem">
            <Ranking
              title="Pedidos por UF"
              filterBy="dsc_uf"
              rows={toRankingOptions(ufs)}
              onFiltering={handleSelectFilter}
            />
            <Ranking
              title="Pedidos por Cidade"
              filterBy="cidade_cliente"
              rows={toRankingOptions(cities)}
              onFiltering={handleSelectFilter}
            />
            <Ranking
              title="Pedidos por Cliente"
              filterBy="cliente_nome"
              rows={toRankingOptions(customers)}
              onFiltering={handleSelectFilter}
            />
            <Ranking
              title="Pedidos por Transportador"
              filterBy="trp_nome"
              rows={toRankingOptions(carriers)}
              onFiltering={handleSelectFilter}
            />
          </Box>
        </Box>
      }
      FooterComponent={
        <Box paddingBottom={20}>
          <Title>
            <span>Pesquisar por</span>

            <Divider />
          </Title>

          <Form
            formRef={formSearchRef}
            onSubmit={handleSubmit}
            initialData={{}}
          >
            <Box
              mt="1rem"
              display="grid"
              gridGap={'0.5rem'}
              gridTemplateColumns={'repeat(2, 1fr)'}
            >
              <Box gridColumn="span 2">
                <FormCombobox
                  name="itens_status"
                  label="Status"
                  options={[
                    { value: 'Sem Estoque', label: 'Sem Estoque' },
                    { value: 'Liberado', label: 'Liberado' },
                    { value: 'Bloqueado', label: 'Bloqueado' },
                  ]}
                />
              </Box>

              <FormTextField fullWidth name="cod_pedido" label="Pedido" />

              <FormDatePicker
                fullWidth
                name="ped_data_emissao"
                label="Data de Emissão"
                variant="inline"
                disableToolbar
              />

              <FormTextField
                fullWidth
                name="ped_seupedido"
                label="Pedido Cliente"
              />

              <FormTextField fullWidth name="cod_produto" label="Cod.Produto" />
            </Box>

            <Box display="flex" justifyContent="flex-end" mt="1rem">
              <Button color="primary" size="small" type="submit">
                Enviar
              </Button>
            </Box>
          </Form>
        </Box>
      }
    />
  )
}
